import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import Colors from "../../../constants/Colors";
import { useSelector, useDispatch } from "react-redux";
import firebase from "firebase";
import DefaultText from "../../../components/text/DefaultText";
import * as deviceActions from "../../../store/actions/device";
import NFTS from "../../../data/dummy_data";
import { useNavigation } from "@react-navigation/native";
import DefaultTextBold from "../../../components/text/DefaultTextBold";
import * as userNftActions from "../../../store/actions/userNft";
import * as userDeviceActions from "../../../store/actions/device";
import { Feather } from "@expo/vector-icons";
import Constants from "expo-constants";

const ProfileSettingScreen = (props) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const myKeys = useSelector((state) => state.userNfts.publicKeys);
  console.log("ProfileSettingScreen key = " + myKeys);
  return (
    <View style={styles.screen}>
      <View style={styles.bottomContainer}>
        <View style={styles.textSection}>
          <DefaultText>Password</DefaultText>
          <TouchableOpacity
            onPress={() => {
              navigation.navigate("ProfileUpdatePWScreen");
            }}
          >
            <Feather name="edit" size={20} color="white" />
          </TouchableOpacity>
        </View>
        <View style={styles.hline} />

        <View style={styles.textSection}>
          <DefaultText>Ethereum Public Key</DefaultText>
          {/* <TouchableOpacity
            onPress={() => {
              navigation.navigate("AddArtworkETHScreen");
            }}
          >
            <Feather name="plus" size={20} color="white" />
          </TouchableOpacity> */}
        </View>
        <View style={styles.hline} />
        {myKeys.map((key) => (
          <View style={styles.ethTextContainer} key={key}>
            <DefaultText
              ellipsizeMode="middle"
              style={styles.ethText}
              numberOfLines={1}
            >
              {key}
            </DefaultText>
            <TouchableOpacity
              style={styles.ethButton}
              onPress={() => {
                dispatch(userNftActions.removePublicKeys());
                dispatch(userNftActions.resetNftDatabase());
              }}
            >
              <Feather name="x" size={18} color="white" />
            </TouchableOpacity>
          </View>
        ))}
      </View>

      <View style={styles.bottomContainer}>
        <TouchableOpacity
          style={styles.linkContainer}
          onPress={() => {
            navigation.navigate("ProfileFAQScreen");
          }}
        >
          <DefaultText style={styles.linkText}>Help/FAQ</DefaultText>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.linkContainer}
          onPress={() => {
            navigation.navigate("ProfilePrivacyScreen");
          }}
        >
          <DefaultText style={styles.linkText}>Privacy Policy</DefaultText>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.linkContainer}
          onPress={() => {
            navigation.navigate("ProfileTermScreen");
          }}
        >
          <DefaultText style={styles.linkText}>Terms of Use</DefaultText>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.logoutContainer}
          onPress={() => {
            firebase.auth().signOut();
          }}
        >
          <DefaultText>Log Out</DefaultText>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => {
            // dispatch(userNftActions.resetNftDatabase());
            //dispatch(userDeviceActions.resetDeviceDatabase());
          }}
        >
          <DefaultText>Version {Constants.manifest.version}</DefaultText>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: Colors.background,
    justifyContent: "space-between",
  },
  bottomContainer: {
    width: "100%",
    alignItems: "center",
    paddingBottom: 30,
    // backgroundColor: "blue",
  },
  textSection: {
    width: "90%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 48,
  },
  ethTextContainer: {
    width: "90%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 20,
  },
  ethText: {
    width: "60%",
  },
  ethButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  linkText: {
    color: Colors.accent,
  },
  linkContainer: {
    marginVertical: 12,
  },
  logoutContainer: {
    borderColor: "white",
    borderWidth: 1,
    width: "90%",
    height: 48,
    alignItems: "center",
    justifyContent: "center",
    margin: 20,
  },
  hline: {
    borderBottomColor: Colors.primary,
    borderBottomWidth: 1,
    width: "90%",
    // width: Dimensions.get("window").width * 0.9,
    marginTop: 8,
  },
});

export default ProfileSettingScreen;
